exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* .logBoxwGrids .fldHldr{position: relative; padding-bottom: 20px !important;}\n.cmn-error{position: absolute; left:2px; line-height: 15px;}\n.signUp button{margin-top:15px;} */", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/signup/signup.component.css
// module id = ../../../../../src/app/pages/signup/signup.component.css
// module chunks = main